<template>
  <v-container fluid>
    <p class="text-center title mt-6">
      {{ this.$vuetify.lang.t("$vuetify.main.redactorDashboard.blog.title") }}
    </p>

    <v-row class="mt-5">
      <v-col cols="12" md="4" class="pt-0">
        <div class="d-flex justify-space-between">
          <p class="text-sm-body-1 font-weight-bold mb-0 pb-0">
            {{
              this.$vuetify.lang.t(
                "$vuetify.main.redactorDashboard.blog.allBlogs"
              )
            }}
          </p>
          <v-btn small class="mb-2" @click="createNewBlog">
            {{
              this.$vuetify.lang.t(
                "$vuetify.main.redactorDashboard.blog.create"
              )
            }}
            <v-icon color="green"> mdi-plus </v-icon>
          </v-btn>
        </div>
        <v-tabs
          v-model="statusTabs"
          centered
          slider-color="white"
          background-color="primary"
        >
          <v-tab class="font-weight-bold font-gotham">{{
            this.$vuetify.lang.t("$vuetify.main.redactorDashboard.blog.all")
          }}</v-tab>
          <v-tab class="font-weight-bold font-gotham">{{
            this.$vuetify.lang.t(
              "$vuetify.main.redactorDashboard.blog.published"
            )
          }}</v-tab>
          <v-tab class="font-weight-bold font-gotham">{{
            this.$vuetify.lang.t("$vuetify.main.redactorDashboard.blog.waiting")
          }}</v-tab>
          <v-tab class="font-weight-bold font-gotham">{{
            this.$vuetify.lang.t("$vuetify.main.redactorDashboard.blog.draft")
          }}</v-tab>
        </v-tabs>
        <v-tabs-items v-model="statusTabs">
          <v-tab-item>
            <v-pagination
              v-model="allBlogsPage"
              :length="paginationLengthAllBlogs"
              prev-icon="mdi-menu-left"
              next-icon="mdi-menu-right"
              :total-visible="6"
              class="mt-3"
            >
            </v-pagination>
            <v-card
              v-for="(blog, i) in allBlogsList"
              :key="i"
              @click="selectBlog(blog)"
              class="mt-2"
            >
              <v-card-title class="text-sm-body-1 font-weight-bold">
                №{{ blog.number + " " }}{{ blog.card_title }}
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="1">
                    <v-icon>{{ setIcon(blog.status) }}</v-icon>
                  </v-col>
                  <v-col cols="12" md="4" v-if="blog.published_at">
                    {{ blog.published_at }}
                  </v-col>
                  <v-col cols="12" md="4" v-if="blog.publish_at">
                    {{ blog.publish_at }}
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card></v-tab-item
          >
          <v-tab-item>
            <v-pagination
              v-model="publishedBlogsPage"
              :length="paginationLengthPublishedBlogs"
              prev-icon="mdi-menu-left"
              next-icon="mdi-menu-right"
              :total-visible="6"
              class="mt-3"
            >
            </v-pagination>
            <v-card
              v-for="(blog, i) in publishedBlogsList"
              :key="i"
              @click="selectBlog(blog)"
              class="mt-2"
            >
              <v-card-title class="text-sm-body-1 font-weight-bold">
                {{ blog.card_title }}
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="6"> {{ blog.published_at }}</v-col>
                  <v-col cols="12" md="4"> </v-col>
                </v-row>
              </v-card-text> </v-card
          ></v-tab-item>
          <v-tab-item>
            <v-card
              v-for="(blog, i) in waitingBlogsList"
              :key="i"
              @click="selectBlog(blog)"
              class="mt-2"
            >
              <v-card-title class="text-sm-body-1 font-weight-bold">
                {{ blog.card_title }}
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="6"> {{ blog.publish_at }}</v-col>
                  <v-col cols="12" md="4"> </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card
              v-for="(blog, i) in draftBlogsList"
              :key="i"
              @click="selectBlog(blog)"
              class="mt-2"
            >
              <v-card-title class="text-sm-body-1 font-weight-bold">
                {{ blog.card_title }}
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="4"> {{ blog.published_at }}</v-col>
                  <v-col cols="12" md="4"> </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
      <v-col cols="12" md="8" class="pt-0">
        <p class="text-sm-body-1 font-weight-bold pb-0 mb-3">
          {{
            this.$vuetify.lang.t(
              "$vuetify.main.redactorDashboard.blog.langDesk"
            )
          }}
        </p>
        <v-tabs
          v-model="tabs"
          centered
          slider-color="white"
          background-color="primary"
        >
          <v-tab> Український</v-tab>
          <v-tab> Русский </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tabs" class="blog-lang-tabs" @click.native="onEditorClick">
          <v-tab-item>
            <v-card>
              <v-form>
                <v-text-field
                  label="SEO заголовок"
                  v-model="SEOTitle.uk"
                ></v-text-field>
                <v-textarea
                  label="SEO опис"
                  v-model="SEODesc.uk"
                  rows="3"
                  auto-grow
                ></v-textarea>
                <v-text-field
                  label="Заголовок"
                  v-model="title.uk"
                ></v-text-field>
                <v-textarea
                  label="Короткий опис"
                  v-model="short_desk.uk"
                  rows="3"
                  auto-grow
                ></v-textarea>
                <v-select
                  v-model="categoriesValue"
                  :items="categoriesItems"
                  item-text="name.uk"
                  item-value="id"
                  chips
                  label="Категорії"
                  attach
                  multiple
                ></v-select>
              </v-form>

              <p class="blog-editor__hint text-caption mb-2 px-1">
                {{ $vuetify.lang.t("$vuetify.main.redactorDashboard.blog.editorHint") }}
              </p>
              <vue-editor
                id="editor-uk"
                class="blog-editor"
                :editorToolbar="editorToolbar"
                useCustomImageHandler
                @image-added="handleImageAdded"
                v-model="content.uk"
              />
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card>
              <v-form>
                <v-text-field
                  label="SEO заголовок"
                  v-model="SEOTitle.ru"
                ></v-text-field>
                <v-textarea
                  label="SEO описание"
                  v-model="SEODesc.ru"
                  rows="3"
                  auto-grow
                ></v-textarea>
                <v-text-field
                  label="Заголовок"
                  v-model="title.ru"
                ></v-text-field>
                <v-textarea
                  label="Краткое описание"
                  v-model="short_desk.ru"
                  rows="3"
                  auto-grow
                ></v-textarea>
                <v-select
                  v-model="categoriesValue"
                  :items="categoriesItems"
                  item-text="name.ru"
                  item-value="id"
                  chips
                  label="Категории"
                  attach
                  multiple
                ></v-select>
              </v-form>
              <p class="blog-editor__hint text-caption mb-2 px-1">
                {{ $vuetify.lang.t("$vuetify.main.redactorDashboard.blog.editorHint") }}
              </p>
              <vue-editor
                id="editor-ru"
                class="blog-editor"
                :editorToolbar="editorToolbar"
                useCustomImageHandler
                @image-added="handleImageAdded"
                v-model="content.ru"
              />
            </v-card>
          </v-tab-item>
        </v-tabs-items>
        <div
          v-if="imageTools.visible"
          class="blog-image-tools"
          :style="{ top: imageTools.top + 'px', left: imageTools.left + 'px' }"
        >
          <span class="blog-image-tools__title">
            {{ $vuetify.lang.t("$vuetify.main.redactorDashboard.blog.imageSize") }}
          </span>
          <v-btn
            v-for="size in imageSizes"
            :key="size.value"
            x-small
            depressed
            :color="imageTools.current === size.value ? 'primary' : ''"
            @click="setImageWidth(size.value)"
          >
            {{ size.label }}
          </v-btn>
        </div>
        <v-card class="px-4 pt-2 pb-1 mt-2" flat>
          <v-autocomplete
            v-model="authorProfileId"
            :items="authors"
            item-text="label"
            item-value="id"
            :label="$vuetify.lang.t('$vuetify.main.redactorDashboard.author')"
            :hint="$vuetify.lang.t('$vuetify.main.redactorDashboard.authorHint')"
            persistent-hint
            clearable
          ></v-autocomplete>
          <v-text-field
            v-if="authorProfileId !== TEAM_AUTHOR"
            v-model="authorUrl"
            :label="$vuetify.lang.t('$vuetify.main.redactorDashboard.authorUrl')"
            placeholder="https://platforma.life/..."
            clearable
          ></v-text-field>
          <v-text-field
            v-model="likesCount"
            type="number"
            min="0"
            :label="$vuetify.lang.t('$vuetify.main.redactorDashboard.likes')"
          ></v-text-field>
        </v-card>
        <div
          v-show="!previewImg"
          class="blog"
          @click="$refs.previewImg.click()"
        >
          <div class="blog__inner">
            <span>
              {{
                this.$vuetify.lang.t(
                  "$vuetify.main.redactorDashboard.blog.previewPhoto"
                )
              }}
            </span>
            <input
              @change="updatePreviewImg"
              hidden
              ref="previewImg"
              type="file"
              accept="image/x-png,image/gif,image/jpeg"
            />
          </div>
        </div>
        <div v-show="previewImg" class="blog__img" id="blog">
          <v-icon @click="deletePreviewImg" class="blog__img_icon"
            >mdi-close</v-icon
          >
        </div>
        <div class="d-flex justify-space-between mt-1">
          <div class="mt-5">
            <v-checkbox
              v-model="publishNow"
              color="primary"
              :label="
                $vuetify.lang.t(
                  `$vuetify.main.redactorDashboard.blog.publishNow`
                )
              "
              class="pt-0 mt-0"
            ></v-checkbox>
          </div>
          <div>
            <v-dialog
              ref="date"
              v-model="dateModal"
              :return-value.sync="publishDate"
              persistent
              width="290px"
              :disabled="publishNow"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="publishDate"
                  :label="
                    $vuetify.lang.t(
                      `$vuetify.main.redactorDashboard.blog.publishDate`
                    )
                  "
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  :disabled="publishNow"
                ></v-text-field>
              </template>
              <v-date-picker v-model="publishDate" scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="dateModal = false">
                  {{
                    this.$vuetify.lang.t(
                      "$vuetify.main.redactorDashboard.blog.cancel"
                    )
                  }}
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.date.save(publishDate)"
                >
                  {{
                    this.$vuetify.lang.t(
                      "$vuetify.main.redactorDashboard.blog.accept"
                    )
                  }}
                </v-btn>
              </v-date-picker>
            </v-dialog>
          </div>
          <div>
            <v-dialog
              ref="dialog"
              v-model="timeModal"
              :return-value.sync="publishTime"
              persistent
              width="290px"
              :disabled="publishNow"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="publishTime"
                  :label="
                    $vuetify.lang.t(
                      `$vuetify.main.redactorDashboard.blog.publishTime`
                    )
                  "
                  prepend-icon="mdi-clock-time-four-outline"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  :disabled="publishNow"
                ></v-text-field>
              </template>
              <v-time-picker
                color="primary"
                v-if="timeModal"
                v-model="publishTime"
                :allowed-minutes="allowedStep"
                full-width
              >
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="timeModal = false">
                  {{
                    this.$vuetify.lang.t(
                      "$vuetify.main.redactorDashboard.blog.cancel"
                    )
                  }}
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.dialog.save(publishTime)"
                >
                  {{
                    this.$vuetify.lang.t(
                      "$vuetify.main.redactorDashboard.blog.accept"
                    )
                  }}
                </v-btn>
              </v-time-picker>
            </v-dialog>
          </div>
          <v-btn small v-if="editBlogToggle" @click="editBlog()" class="mt-5">
            {{
              this.$vuetify.lang.t(
                "$vuetify.main.redactorDashboard.blog.editBlog"
              )
            }}
          </v-btn>
          <v-btn
            small
            v-if="!editBlogToggle"
            @click="createBlog()"
            class="mt-5"
          >
            {{
              this.$vuetify.lang.t(
                "$vuetify.main.redactorDashboard.blog.createBlog"
              )
            }}
          </v-btn>
        </div>
        <div v-if="editBlogToggle" class="d-flex flex-wrap align-center justify-end mt-2 blog-actions">
          <v-btn
            v-if="blogStatus === 'PUBLISHED' && blogSlug"
            small
            text
            color="primary"
            :href="siteUrl + '/blog/posts/' + blogSlug"
            target="_blank"
            rel="noopener"
          >
            <v-icon left small>mdi-open-in-new</v-icon>
            {{ $vuetify.lang.t("$vuetify.main.redactorDashboard.blog.viewOnSite") }}
          </v-btn>
          <v-btn small text color="error" @click="deleteDialog = true">
            <v-icon left small>mdi-delete-outline</v-icon>
            {{ $vuetify.lang.t("$vuetify.main.redactorDashboard.blog.deleteBlog") }}
          </v-btn>
        </div>
        <v-dialog v-model="deleteDialog" max-width="420">
          <v-card>
            <v-card-text class="pt-6 text-body-1">
              {{ $vuetify.lang.t("$vuetify.main.redactorDashboard.blog.deleteConfirm") }}
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="deleteDialog = false">
                {{ $vuetify.lang.t("$vuetify.main.redactorDashboard.blog.cancel") }}
              </v-btn>
              <v-btn color="error" depressed :loading="deleting" @click="deleteBlog">
                {{ $vuetify.lang.t("$vuetify.main.redactorDashboard.blog.deleteYes") }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { EDITOR_PALETTE } from "@/utils/editorPalette";
import Vue from "vue";
import ApiClient from "@/libs/http-client";
import { Quill } from "vue2-editor";

//"author" of an article by the Platforma team (sent as author_team, not as a psychologist id)
const TEAM_AUTHOR = "team";


export default {
  name: "blogComponent",
  metaInfo() {
    return {
      title:
        "Платформа / " + this.$vuetify.lang.t("$vuetify.main.header.menu.blog"),
    };
  },
  data() {
    return {
      TEAM_AUTHOR,
      //headings, emphasis, lists and a highlighted block (blockquote) - the same set the site styles
      editorToolbar: [
        [{ header: [2, 3, false] }],
        ["bold", "italic", "underline"],
        [{ color: EDITOR_PALETTE }, { background: EDITOR_PALETTE }],
        [{ list: "ordered" }, { list: "bullet" }],
        ["blockquote"],
        [{ align: [] }],
        ["link", "image", "video"],
        ["clean"],
      ],
      siteUrl: (process.env.VUE_APP_MAIN_PAGE || "").replace(/\/$/, ""),
      blogStatus: null,
      blogSlug: null,
      deleteDialog: false,
      imageTools: { visible: false, top: 0, left: 0, current: "" },
      imageSizes: [
        { value: "25%", label: "25%" },
        { value: "50%", label: "50%" },
        { value: "75%", label: "75%" },
        { value: "", label: "100%" },
      ],
      deleting: false,
      editorSettings: {
        modules: {
          imageDrop: true,
          imageResize: {},
        },
      },
      tabs: null,
      statusTabs: null,
      content: { uk: null, ru: null },
      allBlogsPage: 1,
      publishedBlogsPage: 1,
      SEOTitle: { uk: null, ru: null },
      SEODesc: { uk: null, ru: null },
      title: { uk: null, ru: null },
      short_desk: { uk: null, ru: null },
      categoriesValue: [],
      authors: [],
      authorProfileId: null,
      authorUrl: null,
      likesCount: 0,
      blogId: null,
      editBlogToggle: false,
      publishNow: true,
      publishTime: null,
      publishDate: null,
      timeModal: null,
      dateModal: null,
      previewImg: null,
    };
  },
  computed: {
    locale() {
      return this.$store.getters["app/getSelectedLocale"];
    },
    allBlogsList() {
      return this.$store.getters["blog/getAllBlogsList"].data;
    },
    publishedBlogsList() {
      return this.$store.getters["blog/getPublishedBlogsList"].data;
    },
    draftBlogsList() {
      return this.$store.getters["blog/getDraftBlogsList"].data;
    },
    waitingBlogsList() {
      return this.$store.getters["blog/getWaitingBlogsList"].data;
    },
    paginationLengthAllBlogs() {
      return this.$store.getters["blog/getAllBlogsList"].meta.last_page;
    },
    paginationLengthPublishedBlogs() {
      return this.$store.getters["blog/getPublishedBlogsList"].meta.last_page;
    },
    categoriesItems() {
      return this.$store.getters["blog/getCategoriesList"].data;
    },
  },
  mounted() {
    window.addEventListener("scroll", this.hideImageTools, true);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.hideImageTools, true);
  },
  beforeMount() {
    this.$store.dispatch("blog/getAllBlogsList", {
      page: this.allBlogsPage,
    });
    this.$store.dispatch("blog/getPublishedBlogsList", {
      page: this.publishedBlogsPage,
    });
    this.$store.dispatch("blog/getDraftBlogsList");
    this.$store.dispatch("blog/getWaitingBlogsList");
    this.$store.dispatch("blog/getCategoriesList");
    ApiClient.get("api/admin/blog/posts/authors").then((response) => {
      // the Platforma team first: its article shows the logo and leads to the psychologists' catalog
      this.authors = [{ id: TEAM_AUTHOR, label: this.$vuetify.lang.t("$vuetify.main.redactorDashboard.authorTeam") }].concat(
        response.data.data.map((author) => ({
          ...author,
          label: author.specialty ? `${author.full_name} — ${author.specialty}` : author.full_name,
        }))
      );
    });
  },
  watch: {
    previewImg() {
      this.setPreviewImg();
    },
    statusTabs: function () {
      switch (this.statusTabs) {
        case 0:
          this.$store.dispatch("blog/getAllBlogsList", {
            page: this.allBlogsPage,
          });
          break;
        case 1:
          this.$store.dispatch("blog/getPublishedBlogsList", {
            page: this.publishedBlogsPage,
          });
          break;
        case 2:
          this.$store.dispatch("blog/getWaitingBlogsList");
          break;
        case 3:
          this.$store.dispatch("blog/getDraftBlogsList");
          break;
      }
    },
    publishNow: function () {
      if (this.publishNow) {
        this.publishDate = null;
        this.publishTime = null;
      }
    },
    allBlogsPage: function () {
      this.$store.dispatch("blog/getAllBlogsList", { page: this.allBlogsPage });
    },
    publishedBlogsPage: function () {
      this.$store.dispatch("blog/getPublishedBlogsList", {
        page: this.publishedBlogsPage,
      });
    },
  },
  methods: {
    handleImageAdded(file, Editor, cursorLocation, resetUploader) {
      let payload = new FormData();
      payload.append("image", file);
      this.$store.dispatch("blog/postBlogImg", payload).then((result) => {
        const url = result.data.data.url;
        Editor.insertEmbed(cursorLocation, "image", url);
        resetUploader();
      });
    },
    setIcon: (status) => {
      switch (status) {
        case "WAITING":
          return "mdi-calendar";
        case "PUBLISHED":
          return "mdi-check-bold";
        case "DRAFT":
          return "mdi-progress-wrench";
      }
    },
    allowedStep: (m) => m % 10 === 0,
    //older articles: empty paragraphs go away, split lists are joined, bold-only paragraphs become subheadings
    cleanContent(html) {
      if (typeof html !== "string") return html;
      return html
        .replace(/<(p|h[1-6])>(?:\s|&nbsp;|<br\s*\/?>)*<\/\1>/gi, "")
        .replace(/<p>\s*<strong>([^<]{2,160})<\/strong>\s*<\/p>/gi, "<h2>$1</h2>")
        .replace(/<\/ul>\s*<ul>/gi, "")
        .replace(/<\/ol>\s*<ol>/gi, "");
    },
    selectBlog(content) {
      this.content = {
        uk: this.cleanContent(content.content && content.content.uk),
        ru: this.cleanContent(content.content && content.content.ru),
      };
      this.SEOTitle = content.seo_title;
      this.SEODesc = content.seo_description;
      this.short_desk = content.short_description;
      this.title = content.title;
      this.previewImg = content.preview_image;

      this.blogStatus = content.status;
      this.blogSlug = content.card_title_slug;
      //keep the current status: a draft stays a draft, a scheduled post keeps its date
      this.publishNow = content.status === "PUBLISHED";
      this.$nextTick(() => {
        if (content.status === "WAITING" && content.publish_at) {
          const [date, time] = content.publish_at.split(" ");
          this.publishDate = date;
          this.publishTime = time ? time.slice(0, 5) : null;
        }
      });
      this.editBlogToggle = true;
      this.blogId = content.id;
      let categories = [];
      content.categories.data.forEach((category) => {
        categories.push(category.id);
      });
      this.categoriesValue = categories;
      this.authorProfileId = content.author_team ? TEAM_AUTHOR : content.author_profile_id || null;
      this.authorUrl = content.author_url || null;
      this.likesCount = content.likes_count || 0;
    },
    createNewBlog() {
      this.content = { uk: null, ru: null };
      this.SEOTitle = { uk: null, ru: null };
      this.title = { uk: null, ru: null };
      this.SEODesc = { uk: null, ru: null };
      this.short_desk = { uk: null, ru: null };
      this.categoriesValue = [];
      this.authorProfileId = null;
      this.authorUrl = null;
      this.likesCount = 0;
      this.publishNow = true;
      this.editBlogToggle = false;
      this.previewImg = null;
      this.blogId = null;
      this.blogStatus = null;
      this.blogSlug = null;
    },
    buildFormData(formData, data, parentKey) {
      if (
        data &&
        typeof data === "object" &&
        !(data instanceof Date) &&
        !(data instanceof File)
      ) {
        Object.keys(data).forEach((key) => {
          this.buildFormData(
            formData,
            data[key],
            parentKey ? `${parentKey}[${key}]` : key
          );
        });
      } else {
        const value = data == null ? "" : data;

        formData.append(parentKey, value);
      }

      return formData;
    },
    // descriptions are typed in a multi-line field, but stay one paragraph (meta description, card text)
    oneLine(langs) {
      const out = {};
      Object.keys(langs || {}).forEach((lang) => {
        const value = langs[lang];
        out[lang] = typeof value === "string" ? value.replace(/\s*\n+\s*/g, " ").trim() : value;
      });
      return out;
    },
    createBlog() {
      let payload = new FormData();
      payload.append("preview_image", this.previewImg);

      let data = {
        content: this.content,
        title: this.title,
        seo_title: this.SEOTitle,
        seo_description: this.oneLine(this.SEODesc),
        categories: this.categoriesValue,
        author_profile_id: this.authorProfileId === TEAM_AUTHOR ? null : this.authorProfileId,
        author_url: this.authorProfileId === TEAM_AUTHOR ? null : this.authorUrl,
        author_team: this.authorProfileId === TEAM_AUTHOR ? 1 : 0,
        likes_count: this.likesCount === "" || this.likesCount === null ? null : Math.max(0, parseInt(this.likesCount, 10) || 0),
        published: this.publishNow ? 1 : 0, //dich from @dymion
        short_description: this.oneLine(this.short_desk),
        publish_at: this.publishDate + " " + this.publishTime + ":00",
      };

      if (!this.publishDate || !this.publishTime) {
        data.publish_at = null;
      }

      let newPayload = this.buildFormData(payload, data);

      this.$store.dispatch("blog/createBlog", newPayload).then((response) => {
        Vue.swal({
          target: document.getElementById("main"),
          text: response.data.message,
          icon: "success",
          timer: 4000,
          toast: true,
          position: "top-right",
          showConfirmButton: false,
        });
        this.statusTabs = 0;
        this.allBlogsPage = 1;
        this.createNewBlog();
      });
    },
    editBlog() {
      let payload = new FormData();

      if (typeof this.previewImg === "string") {
        // link to photo
      } else {
        payload.append("preview_image", this.previewImg);
      }

      let data = {
        content: this.content,
        title: this.title,
        seo_title: this.SEOTitle,
        seo_description: this.oneLine(this.SEODesc),
        categories: this.categoriesValue,
        author_profile_id: this.authorProfileId === TEAM_AUTHOR ? null : this.authorProfileId,
        author_url: this.authorProfileId === TEAM_AUTHOR ? null : this.authorUrl,
        author_team: this.authorProfileId === TEAM_AUTHOR ? 1 : 0,
        likes_count: this.likesCount === "" || this.likesCount === null ? null : Math.max(0, parseInt(this.likesCount, 10) || 0),
        published: this.publishNow ? 1 : 0, //dich from @dymion
        short_description: this.oneLine(this.short_desk),
        publish_at: this.publishDate + " " + this.publishTime + ":00",
      };

      if (!this.publishDate || !this.publishTime) {
        data.publish_at = null;
      }

      let newPayload = this.buildFormData(payload, data);

      this.$store
        .dispatch("blog/editBlog", { data: newPayload, id: this.blogId })
        .then((response) => {
          Vue.swal({
            target: document.getElementById("main"),
            text: response.data.message,
            icon: "success",
            timer: 4000,
            toast: true,
            position: "top-right",
            showConfirmButton: false,
          });
          this.statusTabs = 0;
          this.allBlogsPage = 1;
          this.createNewBlog();
        });
    },
    //click on a picture inside the editor opens the size panel next to it
    onEditorClick(event) {
      const target = event.target;
      if (target && target.tagName === "IMG" && target.closest(".ql-editor")) {
        const rect = target.getBoundingClientRect();
        //never above the sticky header + editor toolbar
        const toolbar = target.closest(".quillWrapper").querySelector(".ql-toolbar");
        const minTop = toolbar ? toolbar.getBoundingClientRect().bottom + 8 : 72;
        this.selectedImage = target;
        this.imageTools = {
          visible: true,
          top: Math.max(rect.top + 8, minTop),
          left: rect.left + 8,
          current: target.getAttribute("width") || "",
        };
        return;
      }
      if (!(target && target.closest && target.closest(".blog-image-tools"))) {
        this.hideImageTools();
      }
    },
    hideImageTools() {
      if (this.imageTools.visible) {
        this.imageTools = { visible: false, top: 0, left: 0, current: "" };
      }
    },
    setImageWidth(width) {
      const img = this.selectedImage;
      if (!img) return;
      const blot = Quill.find(img);
      if (blot && blot.format) {
        blot.format("width", width || null);
      } else if (width) {
        img.setAttribute("width", width);
      } else {
        img.removeAttribute("width");
      }
      //sync v-model with the editor right away
      const root = img.closest(".ql-editor");
      const lang = root && root.closest("#editor-ru") ? "ru" : "uk";
      if (root) {
        this.content = { ...this.content, [lang]: root.innerHTML };
      }
      this.imageTools.current = width;
    },
    deleteBlog() {
      this.deleting = true;
      ApiClient.delete(`api/admin/blog/posts/${this.blogId}`)
        .then((response) => {
          Vue.swal({
            target: document.getElementById("main"),
            text: response.data.message,
            icon: "success",
            timer: 4000,
            toast: true,
            position: "top-right",
            showConfirmButton: false,
          });
          this.deleteDialog = false;
          this.createNewBlog();
          this.$store.dispatch("blog/getAllBlogsList", { page: this.allBlogsPage });
          this.$store.dispatch("blog/getPublishedBlogsList", { page: this.publishedBlogsPage });
          this.$store.dispatch("blog/getDraftBlogsList");
          this.$store.dispatch("blog/getWaitingBlogsList");
        })
        .finally(() => {
          this.deleting = false;
        });
    },
    setPreviewImg() {
      let element = document.getElementById("blog");
      element.style.backgroundImage = `url(${this.previewImg}`;
    },
    updatePreviewImg(e) {
      let previewImg = this.previewImg;
      let element = document.getElementById("blog");
      this.previewImg = e.target.files[0];
      previewImg = URL.createObjectURL(e.target.files[0]);
      element.style.backgroundImage = `url(${previewImg}`;
    },
    deletePreviewImg(e) {
      e.preventDefault();
      let element = document.getElementById("blog");
      this.previewImg = null;
      element.style.backgroundImage = "";
    },
  },
};
</script>

<style lang="scss" scoped>
.blog {
  margin-top: 20px;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0);
  height: 250px;
  width: 450px;
  opacity: 1;
  transition: background-color 0.3s ease;
  &:hover {
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0.1);
  }
  & span {
    font-size: 22px;
  }
  &__inner {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    border: 3px dashed $primary;
    background-color: transparent;
  }
}

.blog__img {
  border: 1px solid $primary;
  position: relative;
  margin-top: 20px;
  height: 250px;
  width: 450px;
  opacity: 1;
  transition: background-color 0.3s ease;
  background-position: center top;
  background-repeat: no-repeat;
  background-size: cover;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  &_icon {
    color: #e0405c;
    position: absolute;
    right: 10px;
    top: 10px;
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 50%;
    padding: 5px;
    &:hover {
      transform: rotate(-20deg);
      cursor: pointer;
    }
  }
}
</style>

<style lang="scss">
//the editor shows text the way the article page does
.blog-editor {
  .ql-toolbar.ql-snow {
    position: sticky;
    top: 64px;
    z-index: 2;
    background: #fff;
  }
  .ql-container.ql-snow {
    font-family: inherit;
  }
  .ql-editor {
    min-height: 480px;
    max-width: 760px;
    margin: 0 auto;
    padding: 24px 20px 40px;
    font-size: 17px;
    line-height: 1.7;
    color: #2f3033;
    p {
      margin-bottom: 0.9em;
    }
    h2 {
      margin: 1.6em 0 0.6em;
      font-size: 28px;
      line-height: 1.25;
      font-weight: 700;
      color: #3c3c3b;
    }
    h3 {
      margin: 1.3em 0 0.5em;
      font-size: 21px;
      line-height: 1.3;
      font-weight: 700;
      color: #3c3c3b;
    }
    ul,
    ol {
      margin-bottom: 1em;
      padding-left: 1.2em;
    }
    li {
      margin-bottom: 0.35em;
    }
    //list dots and numbers in the brand colour, as on the site
    li::before {
      color: #00a3b7;
      font-weight: 700;
    }
    blockquote {
      margin: 1.4em 0;
      padding: 18px 22px;
      border-left: 4px solid #00a3b7;
      border-radius: 0 16px 16px 0;
      background: #e6f6f8;
      color: #2f3033;
      font-style: normal;
    }
    a {
      color: #00a3b7;
    }
    img {
      border-radius: 12px;
    }
  }
  .ql-snow .ql-picker.ql-header {
    width: 130px;
    .ql-picker-label::before,
    .ql-picker-item::before {
      content: "Текст";
    }
    .ql-picker-label[data-value="2"]::before,
    .ql-picker-item[data-value="2"]::before {
      content: "Заголовок";
    }
    .ql-picker-label[data-value="3"]::before,
    .ql-picker-item[data-value="3"]::before {
      content: "Підзаголовок";
    }
  }
}
.blog-lang-tabs,
.blog-lang-tabs .v-window__container {
  overflow: visible;
}
.blog-image-tools {
  position: fixed;
  z-index: 5;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.18);
}
.blog-image-tools__title {
  font-size: 12px;
  color: #6b6b6b;
}
.blog-editor .ql-editor img {
  cursor: pointer;
}
.blog-editor__hint {
  color: #6b6b6b;
}
</style>
